import { useLocation, useParams } from "react-router-dom";

import { DatePickerWithRange } from "./date-range-filter";

import { useTheme } from "@/hooks/useTheme";

const routesTitle = [
  {
    title: "Dashboard",
    path: "/dashboard",
  },
  {
    title: "Configurações",
    path: "/settings",
  },
  {
    title: "Usuários",
    path: "/users",
  },
  {
    title: "Cadastro",
    path: "/register",
  },
  {
    title: "Login",
    path: "/login",
  },
];

export function HeaderAuth() {
  const location = useLocation();
  const { theme } = useTheme();
  const { userTag } = useParams();

  const isVivoUser = userTag === "vivo";
  const headerBgClass = isVivoUser ? "bg-vivo-purple" : "bg-card";

  return (
    <header className={`border-b flex items-center justify-between px-8 min-h-20 w-full sticky top-0 left-0 z-50 ${headerBgClass}`}>
      <div className="flex items-center gap-8">
        <img
          src={
            theme === "dark" ? "/images/pagar-dark.png" : "/images/pagar.png"
          }
          alt="Pagar Logo"
          className="h-8 w-[117px]"
        />
        <h1 className="text-xl font-semibold">
          {routesTitle.find((route) => route.path === location.pathname)?.title}
        </h1>
      </div>

      <div className="flex items-center gap-4">
        {location.pathname === "/dashboard" && (
          <div className="flex items-center gap-2 text-sm">
            <DatePickerWithRange />
          </div>
        )}
      </div>
    </header>
  );
}
